// extracted by mini-css-extract-plugin
module.exports = {"footer":"AppFooter_footer__17-p4"};